var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1.6543","width":"24.5324","height":"2.33769","rx":"1.16885","transform":"rotate(45 1.6543 0)","fill":"white","key":0}),React.createElement("rect",{"y":"17.6656","width":"24.5324","height":"2.15182","rx":"1.07591","transform":"rotate(-45 0 17.6656)","fill":"white","key":1})]);
}

Close.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Close;

Close.default = Close;
